export default [
	{
		text: "Dashboard",
		path: "/home",
		icon: "home"
	},
	{
		text: "",
		disabled: true,
		path: "/placeholder",
		icon: "datapie",
		placeholder: 'groupmenu',
		visible: true,
	},
	{
		text: "Management",
		icon: "folder",
		visible: true,
		items: [
			{
				text: "Blueprints",
				path: "/blueprints",
				icon: 'blank',
			},
			{
				text: "Users",
				path: "/users",
				icon: 'blank',
			},
			{
				text: "Groups",
				path: "/groups",
				icon: 'blank',
			},
			{
				text: "Imports",
				path: "/imports",
				icon: 'blank',
			},
			{
				text: "Settings",
				path: "/settings",
				icon: 'blank',
			}
		]
	}
];
